import './ColorGrid.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ButtonType, Colors } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
// import { Button } from '..';
import { Button, Checkbox } from '@fifth-gear-tech/common-components/dist/components';

import '../../lib/jscolor';

class ColorGrid extends Component {

    componentDidMount() {
        this.load();
    }

    remove = (index) => {
        const { grid } = this.props;
        if (grid && grid.items) {
            if (grid.items[index]) {
                grid.items.splice(index, 1);
                this.props.update(grid);
            }
        }
    }

    edit = (index, field, value) => {
        const { grid } = this.props;
        if (grid && grid.items && grid.items[index]) {
            let row = {};
            row[field] = value;
            grid.items[index] = Object.assign(grid.items[index], row);
            this.props.update(grid);
        }
    }

    update = (index, row) => {

        let { grid = {} } = this.props;

        if (!grid.items) {
            grid.items = [];
        }

        if (grid && grid.items) {
            grid.items[index] = row;
            this.props.update(grid);
        }
    }

    load = () => {
        const { grid } = this.props;
        if (!grid || !grid.items || grid.items?.length <= 0) {
            return null;
        }

        grid.items.forEach((d, i) => {
            try {
                let item = document.getElementById(`color-${i}`);
                if (item._jscLinkedInstance) {
                    return;
                }
                // bit of a hack to get this to work with react
                item.addEventListener('change', () => this.edit(i, 'value', item.value));
                return new window.jscolor(item).fromString(d.value);
            } catch (error) {
                return error;
            }
        });
    }

    rows = () => {
        const { grid } = this.props;
        if (!grid || !grid.items || grid.items?.length <= 0) {
            return null;
        }

        return grid.items.map((d, i) => (
            <div key={`cg-row-${i}`} className={'ColorGrid-row'}>
                <div className={'ColorGrid-row-field'}>
                    <Button
                        label={''}
                        type={ButtonType.Remove}
                        onClick={() => {
                            this.remove(i);
                        }} />
                </div>
                <div className={'ColorGrid-row-field'}>
                    <Checkbox
                        label={''}
                        inputCallback={(val) => this.edit(i, 'visible', val)}
                        defaultChecked={d.visible === true}
                        colorTheme={Colors.Grey}
                    />
                </div>
                <div className={'ColorGrid-row-field'}>
                    <input type={'text'} placeholder={'Enter Field Name'} value={d.label} onChange={(e) => {
                        this.edit(i, 'label', e.target.value);
                    }}></input>
                </div>
                <div className={'ColorGrid-row-field color'}>
                    <input id={`color-${i}`} type={'text'} className={'jscolor'} />
                </div>
            </div>

        ));
    }

    build = () => {
        const { grid } = this.props;
        const next = grid && grid.items ? grid.items?.length : 0;
        return (
            <div className={'ColorGrid'}>
                <div className={'ColorGrid-container'}>
                    <div className={'ColorGrid-header'}>
                        <div className={'ColorGrid-header-field'}>
                            {'Delete Row'}
                        </div>
                        <div className={'ColorGrid-header-field'}>
                            {'Show Text'}
                        </div>
                        <div className={'ColorGrid-header-field'}>
                            {'Field Name'}
                        </div>
                        <div className={'ColorGrid-header-field'}>
                            {'Color ID'}
                        </div>
                    </div>
                    {this.rows()}
                    <div className={'ColorGrid-button-container'}>
                        <Button
                            type={ButtonType.Add}
                            onClick={() => {
                                this.update(next, { label: 'Label', value: 'FFFFFF', visible: true });
                            }}
                            label={'Add Row'} />
                    </div>
                </div>

            </div>
        );
    }

    render() {
        let d = this.build();
        setTimeout(() => {
            this.load();
        }, 0);
        return d;
    }
}


ColorGrid.defaultProps = {};

ColorGrid.propTypes = {
    update: PropTypes.func.isRequired,
    grid: PropTypes.shape().isRequired,
};

export default ColorGrid;